import { Routes } from '@angular/router';
import { TraceManagementComponent } from './trace-management.component';
import { ViewerDetailComponent } from './viewer/detail/viewer-detail.component';
import { CanActivateViaAuthGuard } from '../bz-authentication/bz-can-activate-auth';
import { menus } from '../core/models/constants';

// Route Configuration
export const routesTracing: Routes = [
  {
    path: menus.Tracing.path,
    component: TraceManagementComponent,
    data: { title: menus.Tracing.title },
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.TracingManagement.path,
    component: TraceManagementComponent,
    data: { title: menus.Tracing.title },
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'Tracing/viewer/:file',
    component: ViewerDetailComponent,
    data: { title: menus.Tracing.title },
    canActivate: [CanActivateViaAuthGuard]
  }
];
